function initialize() {
    $('.modal').each(function () {
        const self = $(this);

        function hideModal() {
            self.css('opacity', 0);
            self.css('visibility', 'hidden');
        }

        $(this).find('.modal-dropdrop').on('click', hideModal);
        $(this).find('.btn-close').on('click', hideModal);
    });
}

export function showModal(id) {
    const modal = $(".modal[id='" + id + "']");
    modal.css('opacity', 1);
    modal.css('visibility', 'visible');

    const offset = $(document).scrollTop();

    const zoom = window.innerWidth > 1024 && window.innerWidth < 1367 ? 1 - 0.75 : 0;

    modal.css(
        'top',
        offset * zoom + offset + (window.innerHeight - modal.find('.modal-content').outerHeight()) / 2 + 'px'
    );
}

initialize();
